module.exports = "<dropdown label=\"Dropdown with slot\"> <ul> <li><a href=#!>One</a></li> <li class=divider></li> <li><a href=#!>Two</a></li> <li><a href=#!>Three</a></li> </ul> </dropdown>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../src/demos/dropdown/dropdown-with-slot.vue
 ** module id = 249
 ** module chunks = 0
 **/